export default {
  "divider": "_divider_1vzdu1"
};
